import type { ApiClient } from '../client';
import type { ApiResponse, GradeApiOperationRequest } from '../types';

export function bindGrades(client: ApiClient) {
  return {
async callGradeApi<T = unknown>(operation: GradeApiOperationRequest): Promise<ApiResponse<T>> {
    const qs = new URLSearchParams();
    Object.entries(operation.query || {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      qs.append(key, String(value));
    });
    const query = qs.toString();
    const endpoint = query ? `${operation.path}?${query}` : operation.path;
    const options: RequestInit = { method: operation.method };
    if (operation.method === 'POST' && operation.body) {
      options.body = JSON.stringify(operation.body);
    }
    return client.request<T>(endpoint, options);
  }
  };
}
